import React from 'react';
import {useSearch} from "../../model/useSearch";
import {useProductSearchStore} from "../../model/store";
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

const StyledSuggestionList = styled.div`
    overflow-y: auto;
    margin-bottom: clamp(14px, 3vw, 24px);

    .${GLOBAL_STYLE_CONFIG.splitByPrefix("suggestion-list")} {
        display: flex;
        flex-wrap: nowrap;
        gap: 10px;
        width: max-content;
        padding-bottom: 5px;
    }


`
const StyledSuggestionItem = styled.div`
    padding: 10px;
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('suggestion', 'font-weight')}, 400);
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('suggestion', 'font-size')}, clamp(14px, 2vw, 18px));
    line-height: 120%;
    text-align: center;
    cursor: pointer;
    color: var(${GLOBAL_STYLE_CONFIG.variable('suggestion', 'text-color')},
    ${({theme}) => theme.colors.textSecondary});
    border-bottom: 1px solid;
    border-color: var(${GLOBAL_STYLE_CONFIG.variable('suggestion', 'border-color')}, transparent);
    transition: all 250ms ease-in-out;
    font-family: var(${GLOBAL_STYLE_CONFIG.variable('suggestion', 'font-family')}, inherit);

    &:hover {
        color: var(${GLOBAL_STYLE_CONFIG.variable('suggestion', 'hover-text-color')},
        ${({theme}) => theme.colors.dark});
        border-color: var(${GLOBAL_STYLE_CONFIG.variable('suggestion', 'hover-border-color')},
        ${({theme}) => theme.colors.dark});
    }
`

/**
 * Компонента  отвечате за:
 *  - отображение списка предожений
 *  - получение списка товаров по конретному преложению при клике
 *
 * @returns {JSX.Element | null} - Отображает список подсказок или null
 */
const SuggestionList = () => {
    const {suggestions} = useProductSearchStore();
    const {fetchingSearch} = useSearch();

    const getProductsBySuggest = (suggestValue: string) => {
        fetchingSearch({searchTerm: suggestValue, startIndex: 0})
    }

    if (!Array.isArray(suggestions) || !suggestions.length) {
        return null
    }
    return (
        <StyledSuggestionList className={GLOBAL_STYLE_CONFIG.splitByPrefix('suggestion')}>
            <div className={GLOBAL_STYLE_CONFIG.splitByPrefix('suggestion-list')}>
                {suggestions.map((text, index) => {
                    return (<StyledSuggestionItem
                        className={GLOBAL_STYLE_CONFIG.splitByPrefix('suggestion-item')}
                        key={`suggestion-item-${text}`}
                        onClick={() => {
                            getProductsBySuggest(text.toString())
                        }}>
                        {text}
                    </StyledSuggestionItem>)
                })}
            </div>
        </StyledSuggestionList>
    );
};

export default SuggestionList;